__turbopack_context__.v({
  "actions": "DhpSDW_actions",
  "animateOpen": "DhpSDW_animateOpen",
  "cancelButton": "DhpSDW_cancelButton",
  "cancellationSlotVisible": "DhpSDW_cancellationSlotVisible",
  "fields": "DhpSDW_fields",
  "form": "DhpSDW_form",
});
